import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { initAnalytics } from './lib/analytics'

initAnalytics();

Sentry.init({
  dsn: 'https://e3757a5e8ba3faaafd7284558e5853d1@o4511353581469696.ingest.de.sentry.io/4511353622822992',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});

createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen bg-[#F0F9FF] flex flex-col items-center justify-center p-6 font-inter">
          <div className="bg-white rounded-[32px] shadow-xl border border-red-100 p-10 max-w-md text-center">
            <div className="text-4xl mb-4">⚠️</div>
            <h2 className="text-xl font-black text-slate-900 mb-2">Une erreur est survenue</h2>
            <p className="text-slate-500 text-sm mb-6">Notre équipe a été notifiée automatiquement.</p>
            <button
              onClick={resetError}
              className="bg-blue-600 text-white font-bold px-6 py-3 rounded-xl hover:bg-blue-700 transition-all"
            >
              Réessayer
            </button>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </HelmetProvider>
)
